import ManifestListItem from "./components/ManifestListItem";
import translations from './locales';

export default [
  {
    component: ManifestListItem,
    mode: 'wrap',
    target: 'ManifestListItem',
    config: {
      translations
    }
  }
];
